import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing(5)};
    background-color: #4c2f82;
    color: ${theme.palette.white};

    ${theme.media('sm')} {
      padding: ${theme.spacing(5)} ${theme.spacing(10)};
    }
  `}
`

const Content = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    align-items: center;
    gap: ${theme.spacing(3)};
    width: 100%;
    max-width: 110rem;
    margin: 0 auto;
    text-align: center;

    ${theme.media('sm')} {
      grid-template-columns: auto 1fr auto;
      justify-items: baseline;
      text-align: left;
    }

    img {
      height: 13rem;
      width: auto;
      max-width: 100%;
      object-fit: contain;
      margin: 0 auto;
      order: 3;

      ${theme.media('sm')} {
        height: 8rem;
        order: 0;
      }

      ${theme.media('md')} {
        height: 13rem;
      }
    }

    h4 {
      margin: 0;
    }
  `}
`

export default {
  Wrapper,
  Content,
}
